import React, { useState } from "react";
import {Row, Col, Modal, Form, Button} from "react-bootstrap";
import OrgPickerModal from "organizations/OrgPickerModal"
import jsDig from "utils/jsDig"

export default function ProfileDropdown(props) {
  let logout = require("images/organizations/logout.png");
  logout = <img style={{paddingBottom:"3px", paddingRight:"12px"}} src={`/datapulse${logout}`} />;
  let dpLogo = require("images/logos/dp-logo-white.png");
  dpLogo = <img width="40" height="40" className="avatar-picker" style={{paddingBottom:"3px", paddingRight:"1px"}} src={`/datapulse${dpLogo}`} />;


  const [imageURL, setImageURL] = useState(props.logo ? props.logo : '');
 
  let orgLogo = <img width="40" hieght="40" className="avatar-picker" style={{paddingBottom:"3px", paddingRight:"1px"}} src={`${imageURL}`} />;

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  const userOrgDetail = props.user_org_details.find((el) => el.organization_id == jsDig(["selected_org", "id"], props))
  const getRoleTitle = (role) => {
    // :nobody, :client, :employee, :specialist, :manager, :admin
    switch(role) {
      case "admin":
        return "Admin";
      case "manager":
        return "Full";
      case "specialist":
        return "Standard";
      case "employee":
        return "Restricted"
      case "client":
        return "Client";
      default:
        return "Nobody";
    }
  }

  return (
    <div className="profile-dropdown p-2">
      {(props.organizations && props.organizations.length) > 0 && (
        <>
          <Row className="top p-2 mx-0">
            <Col>
            <Row className="pb-2 align-items-center">
              <Col>
            <p className="f10 text-left">Organization</p>
              </Col>
              {props.organizations.length > 1 &&
                <Col>
                <p onClick={handleShow} style={{whiteSpace: "nowrap"}} className="f14 profile-dropdown-item text-info text-right">Change Organization</p>
                </Col>
              }
            </Row>
            <Row className="pb-2">
              <Col>
              <Row>
                <Col xs={3}>
                {props.logo ? orgLogo : dpLogo}
                </Col>
                <Col>
                <Row>
                  <Col>
                  <p style={{whiteSpace: "nowrap"}}className="f16">{props.selected_org ? props.selected_org.name : "None"}</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="f12">{getRoleTitle(jsDig(["role"], userOrgDetail))}</p>
                  </Col>
                </Row>
                </Col>
                </Row>
              </Col>
              <Col xs={4}>
              </Col>
            </Row>
            {
              (getRoleTitle(jsDig(["role"], userOrgDetail)) === "Admin" || props.current_user_is_god) &&
              <Row>
              <Col>
              <a className="f14 profile-dropdown-item text-info" href={window.location.origin + '/datapulse/organization/' + jsDig(["selected_org", "id"], props)}>Organization Settings</a>
              </Col>
            </Row>
            }
            </Col>
          </Row>
        </>
      )}
      <Row className="bot p-2 mx-0">
        <Col>
        <a href={window.location.origin + '/datapulse/profile'} style={{lineHeight:"1.75"}} className="f14 profile-dropdown-item text-info">Edit My Profile</a><br></br>
        <a href={window.location.origin + '/datapulse/my-team'} style={{lineHeight:"1.75"}}  className="f14 profile-dropdown-item text-info">My Team</a><br></br>
        {/* <a href={window.location.origin + '/datapulse/profile'} style={{lineHeight:"1.75"}}  className="f14 profile-dropdown-item text-info">{logout}Logout</a><br></br> */}
        <a className="f14 profile-dropdown-item text-info" rel="nofollow" data-method="delete" href={props.logout_path}>{logout}Logout</a>
        </Col>
      </Row>
      {(props.organizations && props.organizations.length > 0) && (
        <OrgPickerModal show={show} setShow={setShow} selectedOrg={props.selected_org} organizations={props.organizations} />
      )}
    </div>
  );
}

